/**
 * Write-a-review popup that submits to Judge.me (snippets/judgeme-review-modal.liquid).
 * Any element with data-jm-review-open="<modal id>" opens the matching popup
 * (an empty value opens the first popup on the page).
 */
(function() {
  if (window.ChronoReviewModal) return;

  var JUDGEME_REVIEWS_URL = 'https://api.judge.me/api/v1/reviews';

  function setRating(modal, rating) {
    var input = modal.querySelector('[data-jm-rating-value]');
    if (input) input.value = String(rating);
    modal.querySelectorAll('[data-jm-rating] [data-rating]').forEach(function(star) {
      var value = parseInt(star.getAttribute('data-rating'), 10) || 0;
      star.classList.toggle('is-active', value <= rating);
      star.setAttribute('aria-checked', value === rating ? 'true' : 'false');
    });
  }

  function showMessage(modal, message, type) {
    var messageEl = modal.querySelector('[data-jm-review-message]');
    if (!messageEl) return;
    messageEl.hidden = false;
    messageEl.textContent = message;
    messageEl.classList.toggle('is-success', type === 'success');
    messageEl.classList.toggle('is-error', type !== 'success');
  }

  function hideMessage(modal) {
    var messageEl = modal.querySelector('[data-jm-review-message]');
    if (messageEl) messageEl.hidden = true;
  }

  function openModal(modal, trigger) {
    modal._jmTrigger = trigger || null;
    hideMessage(modal);
    modal.hidden = false;
    window.requestAnimationFrame(function() {
      modal.classList.add('is-open');
    });
    document.body.classList.add('overflow-hidden');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var firstInput = modal.querySelector('input:not([type="hidden"]), select, textarea');
    if (firstInput) window.setTimeout(function() { firstInput.focus(); }, 100);
  }

  function closeModal(modal) {
    if (modal.hidden) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (modal._jmTrigger) {
      modal._jmTrigger.setAttribute('aria-expanded', 'false');
      modal._jmTrigger.focus();
    }
  }

  function submitReview(modal, form) {
    var shopDomain = modal.getAttribute('data-shop-domain') || '';
    var successMessage = modal.getAttribute('data-success-message') || 'Thank you for your review.';
    var errorMessage = modal.getAttribute('data-error-message') || 'Unable to submit your review. Please try again.';
    var requireProduct = modal.getAttribute('data-require-product') === 'true';
    var submitBtn = form.querySelector('[data-jm-review-submit]');

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var formData = new FormData(form);
    var productId = String(formData.get('product_id') || '').trim();
    if (!shopDomain || (requireProduct && !productId)) {
      showMessage(modal, errorMessage, 'error');
      return;
    }

    var payload = new FormData();
    payload.append('shop_domain', shopDomain);
    payload.append('platform', 'shopify');
    payload.append('name', String(formData.get('name') || '').trim());
    payload.append('email', String(formData.get('email') || '').trim());
    payload.append('rating', String(parseInt(formData.get('rating'), 10) || 5));
    payload.append('body', String(formData.get('body') || '').trim());
    var title = String(formData.get('title') || '').trim();
    if (title) payload.append('title', title);
    if (productId) payload.append('id', productId);

    if (submitBtn) submitBtn.disabled = true;
    hideMessage(modal);

    fetch(JUDGEME_REVIEWS_URL, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: payload
    })
      .then(function(response) {
        return response.json().catch(function() { return {}; }).then(function(data) {
          if (!response.ok) throw new Error((data && (data.error || data.message)) || errorMessage);
          return data;
        });
      })
      .then(function() {
        showMessage(modal, successMessage, 'success');
        form.reset();
        setRating(modal, 5);
        window.setTimeout(function() { closeModal(modal); }, 2500);
      })
      .catch(function(error) {
        showMessage(modal, (error && error.message) || errorMessage, 'error');
      })
      .then(function() {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function initModal(modal) {
    if (modal._jmReady) return;
    modal._jmReady = true;

    // Move to <body> so the fixed popup is not clipped by section stacking contexts.
    // Drop any stale copy left behind when the theme editor re-renders the section.
    var stale = document.querySelectorAll('[data-jm-review-modal][id="' + modal.id + '"]');
    stale.forEach(function(el) {
      if (el !== modal) el.remove();
    });
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    modal.querySelectorAll('[data-jm-review-close]').forEach(function(btn) {
      btn.addEventListener('click', function() { closeModal(modal); });
    });

    modal.querySelectorAll('[data-jm-rating] [data-rating]').forEach(function(star) {
      star.addEventListener('click', function() {
        setRating(modal, parseInt(star.getAttribute('data-rating'), 10) || 5);
      });
    });

    var form = modal.querySelector('[data-jm-review-form]');
    if (form) {
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        submitReview(modal, form);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-jm-review-modal]').forEach(initModal);
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-jm-review-open]');
    if (!trigger) return;
    // An empty data-jm-review-open uses the first review popup on the page.
    var targetId = trigger.getAttribute('data-jm-review-open');
    var modal = targetId ? document.getElementById(targetId) : document.querySelector('[data-jm-review-modal]');
    if (!modal) return; // No popup on the page: let the link navigate normally.
    event.preventDefault();
    initModal(modal);
    openModal(modal, trigger);
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-jm-review-modal].is-open').forEach(closeModal);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  window.ChronoReviewModal = { init: initAll };
})();
